<script>
import { toFormattedNumber } from '@/utils/number'

export default {
  props: {
    label: {
      type: String,
      default: ''
    },

    value: {
      type: Number,
      default: 0
    },

    unit: {
      type: String,
      default: ''
    }
  },

  render() {
    return (
      <div class={this.$style.root}>
        <el-row type="flex" gutter={16}>
          <el-col span={null} class={this.$style.label}>
            {this.label}
          </el-col>
          <el-col span={null} class={this.$style.value}>
            {toFormattedNumber(this.value, 2)}
          </el-col>
          <el-col span={null}>{this.unit}</el-col>
        </el-row>
      </div>
    )
  }
}
</script>

<style lang="scss" module>
.root {
  font-size: 0.75rem;
}

.label {
  min-width: 10em;
  text-align: right;
}

.value {
  font-weight: bold;
  text-align: right;
  min-width: 8em;
}
</style>
